import { Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IFund from '../../../../../interfaces/fund/IFund';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';

type CFiltersThematiqueSelectProps = {
	optionsThematiques: { id: string; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
	label: string;
	multipleRenderLabelLangTag: string;
};

const CFiltersThematiqueSelect = (props: CFiltersThematiqueSelectProps) => {
	const { optionsThematiques, filters, onChange, label, multipleRenderLabelLangTag } = props;

	const { t } = useTranslation();

	return (
		<>
			{optionsThematiques ? (
				<CAppFilterSelect
					className="filter-thematiques"
					multiple
					multipleRenderTags={(val: IFund[]) => (
						<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
							{t(multipleRenderLabelLangTag, { count: val ? val.length : 0 })}
						</Box>
					)}
					value={
						filters &&
						filters.thematiques &&
						optionsThematiques.filter((x) => filters.thematiques?.includes(x.id))
					}
					onChange={(val: { id: string; name: string }[]) =>
						onChange({
							...filters,
							thematiques: val ? val.map((x) => x.id) : null,
						})
					}
					label={label}
					size="small"
					options={optionsThematiques}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default CFiltersThematiqueSelect;
